import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, useI18n } from '@catawiki/cata-style';
import { EventBus, Environment } from '@catawiki/runtime-toolkit';
import { useIsUserLoggedIn } from '../../hooks/useIsUserLoggedIn';
const UNIQUE_ITEMS_COUNT = 65000;
const EXPERTS_APPROXIMATE_COUNT = 240;
export const Authentication = () => {
    const isLoggedIn = useIsUserLoggedIn();
    const i18n = useI18n();
    if (isLoggedIn)
        return null;
    const handleOnLoginClick = () => {
        const isLoginPage = (Environment.isClientSide() ? window.location.pathname : '').endsWith('accounts/login');
        if (!isLoginPage) {
            EventBus.showScreen({
                screen: EventBus.Screen.SIGN_IN,
            });
        }
    };
    const handleOnSignUpClick = () => {
        EventBus.showScreen({
            screen: EventBus.Screen.SIGN_UP,
        });
    };
    return (_jsx("div", { className: "u-p-v-m u-border-t-style-solid u-border-t-width-1 u-border-t-color-light-gray", children: _jsxs("div", { className: "u-wrapper u-flex u-flex--align-items-center", children: [_jsx(Button, { className: "u-m-r-m", onClick: handleOnLoginClick, children: i18n.t('login') }), _jsx(Button, { onClick: handleOnSignUpClick, children: i18n.t('register') }), _jsx("div", { className: "u-flex-1 u-text-right u-color-black u-hide-m u-hide-s", children: _jsx("div", { className: "u-typography-h7", children: i18n.t('unique_objects_and_experts_rebrand_html_static', {
                            objects: i18n.toNumber(UNIQUE_ITEMS_COUNT, { precision: 0 }),
                            experts: i18n.toNumber(EXPERTS_APPROXIMATE_COUNT, {
                                precision: 0,
                            }),
                        }) }) })] }) }));
};
//# sourceMappingURL=Authentication.js.map